module.exports = __webpack_public_path__ + "fonts/icons.0ab54153.0ab54153.woff2";